import React from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loginLottie from "../static/login-asset/wm-login-lottie.json";
import Logo from "../common-components/Logo";
import { AppConstants } from "../constants";

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleRelogin = () => {
    navigate('/');
  };

  return (
    <div className="login-container">
      <div className="row">
        <div className="login-left-section col-xs-12 col-sm-5 col-md-5 col-lg-5">
          <div className="login-content">
            <Logo />
            <div className="form-container login">
              <div className="form-title">
                <h1>Signed Out of WaveMaker</h1>
              </div>
              <div className="form-row">
                <div className="row">
                  <div className="col-sm-12">
                    <p className="redirect-message">You have signed out.</p>
                    <p className="redirect-message">To sign in again, click on Relogin</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 no-padding">
                    <button
                      type="button"
                      className="btn btn-primary btn-submit btn-block"
                      onClick={handleRelogin}
                    >
                      Relogin
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="copyright-text">
            © {currentYear} WaveMaker. All Rights Reserved
          </p>
        </div>
        <div className="login-right-section col-xs-12 col-sm-7 col-md-7 col-lg-7">
          <div className="right-content-wrapper">
            <h3 className="right-section-title">
              {AppConstants.CAROUSELTITLE}
            </h3>
            <Lottie
              animationData={loginLottie}
              loop={true}
              className="lottie-animation"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;